import { PropagateLoader } from 'react-spinners'

export default function Loader() {
    return (
        <>
            <div className="text-center mb-3">
                <PropagateLoader
                    color="#14335d"
                    size={20}
                />
            </div>
        </>
    )
}
